export default __webpack_public_path__ + "static/media/847.dcaf8c04.jpg";